import React from 'react';
import { Form, FieldGroup, FieldLabel, ButtonGroup } from './styles';
import Button from '../Common/AdminButton/Button';
import Skeleton from 'react-loading-skeleton';
function TicketReminderFormSkeleton() {
    return (React.createElement(Form, null,
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "# Ticket"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Destinatario"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Fecha"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { disabled: true, className: "white", type: "button" }, "Cancelar"),
            React.createElement(Button, { disabled: true, type: "submit" }, "Guardar"))));
}
export default TicketReminderFormSkeleton;
